/**
 * 공개 사이트 페이지 본문 문구 — `landing` 네임스페이스의 `site` 아래에 합쳐진다(`site.plan.*` 등).
 * 문구 안 `<br/>`·`<brd/>`·`<brm/>`·`<b>` 는 사이트 문구 태그(SiteText)다.
 */
const landingPages = {
  news: {
    eyebrow: "언론보도",
    title: "언론보도",
    count: "전체 {{n}}건",
    listLabel: "기사 목록",
    readMore: "기사 읽기",
    openLabel: "{{title}} — 기사 보기",
    back: "목록으로",
    original: "원문보기",
    empty: "아직 등록된 기사가 없습니다.",
    imageUnavailable: "이미지를 불러올 수 없습니다",
    translatedFrom: {
      ja: "일본어 원문을 우리말로 옮긴 글입니다.",
    },
    related: {
      title: "함께 보면 좋아요",
      platform: {
        alt: "DroneSquare 앱 아이콘 타일이 정사영상·도면·3D 레이어 판 위에 떠 있는 그림",
        kicker: "서비스 플랫폼",
        title: "드론 기반 인프라 관리 플랫폼",
        text: "드론으로 찍은 현장을 2D·3D로 점검하고 기록합니다.",
      },
      releases: {
        alt: "숫자 3 알림 표시가 달린 금색 알림 종이 울리고, 그 아래 DroneSquare 앱 알림 카드가 있는 그림",
        kicker: "업데이트 소식",
        title: "더 새로워진 드론스퀘어",
        text: "새로 더해진 기능을 시연 영상과 함께 만나 보세요.",
      },
    },
  },
  plan: {
    title: "드론스퀘어 서비스 플랜",
    lead: "드론스퀘어가 제공하는 정확한 데이터 분석으로<br/>현장을 모니터링하고 최적의 유지보수를 실현하세요.",
    plansLabel: "플랜",
    standard: {
      name: "Standard Plan",
      description:
        "<b>소규모 대상 객체(현장)</b>을<br/>분석하고 관리하고자 하는 경우",
      features: [
        "월 구독 방식",
        "드론 이미지 3000장 / 드론 프로젝트 구축",
        "월 2회 데이터 처리",
      ],
    },
    advanced: {
      name: "Advanced Plan",
      description:
        "<b>대규모 대상 객체(현장)</b>을<br/>분석하고 관리하고자 하는 경우",
      features: [
        "년 구독 방식으로\n각종 사용 옵션을 유연하게 협의",
        "드론 이미지 3000장 + / 드론 프로젝트 구축",
      ],
    },
    ask: "문의하기",
    compare: {
      title: "한눈에 비교",
      item: "항목",
      rows: [
        {
          label: "대상",
          standard: "소규모 대상 객체(현장)",
          advanced: "대규모 대상 객체(현장)",
        },
        { label: "구독 방식", standard: "월 구독", advanced: "년 구독" },
        {
          label: "드론 프로젝트 구축",
          standard: "드론 이미지 3000장",
          advanced: "드론 이미지 3000장 +",
        },
        {
          label: "데이터 처리",
          standard: "월 2회",
          advanced: "사용 옵션 유연 협의",
        },
      ],
    },
    related: {
      title: "플랜과 함께 보면 좋아요",
      platform: {
        alt: "DroneSquare 앱 아이콘 타일이 정사영상·도면·3D 레이어 판 위에 떠 있는 그림",
        kicker: "플랫폼",
        title: "드론 기반 인프라 관리 플랫폼",
        text: "2D·3D·4D, 측량·단면, 모든 데이터 중첩과 현장 기록까지 한 화면에서.",
      },
      survey: {
        alt: "물 위를 나는 드론",
        kicker: "드론 측량 및 공간 데이터 가공",
        title: "촬영부터 플랫폼까지 맡기기",
        text: "드론 운용 전문가가 비행 승인부터 플랫폼까지 직접 진행합니다.",
      },
    },
    closing: {
      eyebrow: "DroneSquare 1:1 문의",
      title: "현장에 맞는 플랜을<br/>함께 정해 드립니다",
    },
  },
  inquiry: {
    eyebrow: "1:1 문의",
    title: "DroneSquare 1:1 문의",
    copy: "드론 스퀘어와 함께하는<br/><em>스마트한 인프라 자산 관리/분석</em>",
    photoAlt: "현장 위를 나는 촬영용 드론",
    chatTitle: "DroneSquare 1:1 상담",
    chatFallback: "이 브라우저에서는 상담 창을 띄울 수 없습니다.",
    chatLoading: "상담 창을 여는 중이에요",
    chatFailedTitle: "상담 창을 열지 못했어요",
    chatFailedText: "잠시 뒤 다시 시도하거나 대표전화로 문의해 주세요.",
    chatRetry: "다시 시도",
    chatCall: "대표전화 {{tel}}",
    chatOpen: "채팅으로 문의하기",
    chatClose: "닫기",
    moreTitle: "문의 전에 살펴보세요",
    manual: {
      alt: "DroneSquare 앱 아이콘 타일 옆에 단계 1·2·3이 적힌 안내 카드와 커서가 있는 그림",
      kicker: "매뉴얼",
      title: "화면별 사용 방법",
      text: "프로젝트 만들기부터 3D 측정까지 따라 해 보세요.",
    },
    plan: {
      alt: "DroneSquare 앱 아이콘 타일 옆에 Standard·Advanced 플랜 카드 두 장이 있는 그림",
      kicker: "이용 플랜",
      title: "Standard · Advanced",
      text: "현장 규모에 맞는 플랜을 비교해 보세요.",
    },
    survey: {
      alt: "등각 현장 판 위를 점선 경로로 나는 드론과 수치지형도 결과 카드가 있는 그림",
      kicker: "드론 측량 서비스",
      title: "촬영부터 플랫폼까지",
      text: "드론 운용 전문가가 직접 촬영하고 처리합니다.",
    },
  },
  survey: {
    eyebrow: "드론 측량 및 공간 데이터 가공",
    title: "전문가가 만드는<br/>end-to-end 드론 솔루션",
    description:
      "드론 운용 전문가가 고객의 요구사항에 맞춰 대상 지역 촬영부터 고정밀 지도 제작까지 빠르고 정확하게 진행합니다.",
    heroAlt: "숲 위를 나는 흰색 촬영용 드론",
    ask: "문의하기",
    process: {
      eyebrow: "진행 절차",
      title: "비행 승인부터<br/>플랫폼까지",
    },
    results: {
      eyebrow: "결과물",
      title: "한 번의 촬영으로 만드는 결과물",
      lead: "모든 결과물은 드론스퀘어 플랫폼에 올려 2D·3D 화면에서 바로 확인합니다.",
      tabsLabel: "결과물 종류",
      tabs: [
        {
          name: "정사영상",
          note: "왜곡을 보정한 고해상도 지도",
          alt: "결과물: 정사영상. 토공 현장을 북동쪽 위에서 비스듬히 본 지도 면.",
        },
        {
          name: "DSM",
          note: "지표면 높이 모델",
          alt: "결과물: 같은 시점의 DSM. 낮은 곳은 파랑, 높은 곳은 빨강으로 칠해진다.",
        },
        {
          name: "Point Cloud",
          note: "사진을 정합해 만든 점 데이터",
          alt: "결과물: 같은 시점의 Point Cloud. 현장이 촘촘한 색 점으로 입체로 보인다.",
        },
        {
          name: "3D 모델",
          note: "실사 텍스처 입체 모델",
          alt: "결과물: 같은 시점의 3D 모델. 깎인 비탈과 진입로가 입체로 보인다.",
        },
        {
          name: "간이 수치지형도",
          note: "1미터 간격 등고선",
          alt: "결과물: 같은 시점의 간이 수치지형도. 1미터 간격 등고선과 5미터 계곡선.",
        },
      ],
    },
    closing: {
      eyebrow: "플랫폼",
      title: "드론 기반<br/>인프라 관리 플랫폼",
      more: "더 알아보기",
      ask: "문의하기",
    },
  },
  accurate: {
    eyebrow: "플랫폼",
    title: "드론 기반<br/>인프라 관리 플랫폼",
    description:
      "드론 스퀘어를 도입해 공간 데이터를 가치있는 비즈니스 인텔리전스로 전환하세요.",
    start: "시작하기",
    ask: "문의하기",
    heroVideoLabel:
      "DroneSquare 3D 점검 화면 전체. 왼쪽 이슈 패널과 도구 모음, 드론으로 만든 터파기 공사 현장 3D 모델을 비스듬히 내려다보며 천천히 도는 영상.",
    index: {
      title: "현장의 모든 데이터를<br/>한 화면에서",
      label: "플랫폼 기능",
      items: [
        {
          title: "2D · 3D · 4D",
          text: "정사영상과 3D 모델을 오가고, 화면을 나눠 촬영일별로 비교합니다.",
        },
        {
          title: "측량 · 단면 · 토공",
          text: "선을 그어 지형과 구조물 단면을 보고, 토공량과 길이·면적·체적을 잽니다.",
        },
        {
          title: "모든 데이터",
          text: "DXF·GIS·BIM·Point Cloud·벡터를 한 3D 화면에 겹치고 잘라 봅니다.",
        },
        {
          title: "현장 기록 · 작업현황",
          text: "이슈와 사진·영상·360°를 위치마다 남기고, 장비 동선 위험을 확인합니다.",
        },
      ],
    },
    site: {
      eyebrow: "현장 기록 · 작업현황",
      title: "현장의 기록과 장비 위험까지<br/>한 지도에서",
      lead: "이슈와 사진·영상·360° 기록을 위치마다 남기고,<brd/> 장비 동선을 미리 돌려 작업반경이 겹치는 곳을 확인하세요.",
    },
    more: {
      title: "더 알아보기",
      survey: {
        alt: "물 위를 나는 촬영용 드론",
        kicker: "드론 측량 및 공간 데이터 가공",
        title: "전문가가 만드는 end-to-end 드론 솔루션",
        text: "비행 승인부터 플랫폼까지, 드론 운용 전문가가 직접 진행합니다.",
      },
      plan: {
        alt: "Standard·Advanced 플랜 카드 두 장이 나란히 있는 그림",
        kicker: "이용 플랜",
        title: "드론스퀘어 서비스 플랜",
        text: "현장 규모에 맞는 Standard, Advanced 플랜을 비교해 보세요.",
      },
    },
    closing: {
      eyebrow: "다음 단계",
      title: "드론 측량 및<br/>공간 데이터 가공",
      more: "더 알아보기",
      ask: "문의하기",
    },
  },
  landing: {
    hero: {
      title: "드론 기반 인프라 관리 플랫폼",
      ask: "문의하기",
      start: "시작하기",
      sceneLabel:
        "드론이 터파기 공사 현장 위를 날며 사진을 찍고, 사진이 한 장의 정사영상으로 맞춰진 뒤 같은 자리가 3D 모델로 일어나는 장면",
    },
    service: {
      eyebrow: "드론 측량 및 공간 데이터 가공",
      title: "전문가가 만드는<br/>end-to-end 드론 솔루션",
      lead: "드론 운용 전문가가 고객의 요구사항에 맞춰<brd/> 대상 지역 촬영부터 고정밀 지도 제작까지 빠르고 정확하게 진행합니다.",
    },
    closing: {
      eyebrow: "DroneSquare 1:1 문의",
      title: "드론 스퀘어와 함께하는 스마트한 인프라 자산 관리·분석",
    },
  },
  status: {
    home: "홈으로",
    notFound: {
      title: "페이지를 찾을 수 없어요",
      lead: "주소가 바뀌었거나 없어진 페이지예요.",
    },
    prepare: {
      title: "준비 중인 페이지예요",
      lead: "빠른 시일 안에 준비해 찾아뵐게요.",
    },
  },
  meta: {
    siteName: "DroneSquare",
    imageAlt:
      "드론 사진을 한 장으로 맞춘 공사 현장 정사영상 위에 왼쪽 DroneSquare 로고와 DroneSquare, 그 아래 「드론 기반 인프라 관리 플랫폼」이 놓인 그림",
    landing: {
      title: "DroneSquare | 드론 기반 인프라 관리 플랫폼",
      description:
        "드론으로 찍은 현장을 2D·3D 로 보고 점검하고 관리하는 인프라 관리 플랫폼입니다.",
    },
    accurate: {
      title: "플랫폼 | DroneSquare",
      description:
        "드론 스퀘어를 도입해 공간 데이터를 가치있는 비즈니스 인텔리전스로 전환하세요.",
    },
    survey: {
      title: "드론 측량 및 공간 데이터 가공 | DroneSquare",
      description:
        "드론 운용 전문가가 비행 승인부터 정사영상·DSM·3D 모델·간이 수치지형도까지 직접 만듭니다.",
    },
    plan: {
      title: "이용 플랜 | DroneSquare",
      description: "현장 규모에 맞는 Standard, Advanced 플랜을 비교해 보세요.",
    },
    inquiry: {
      title: "1:1 문의 | DroneSquare",
      description:
        "드론스퀘어 도입과 이용 문의를 채팅 상담과 대표전화로 받습니다.",
    },
    news: {
      title: "언론보도 | DroneSquare",
      description: "드론스퀘어를 다룬 언론 기사를 모았습니다.",
    },
    manual: {
      title: "매뉴얼 | DroneSquare",
      description:
        "영상을 따라 하며 드론스퀘어 화면별 사용 방법을 익혀 보세요.",
    },
    releases: {
      title: "업데이트 소식 | DroneSquare",
      description: "가장 앞선 현장 기술을 드론스퀘어에서 먼저 만나 보세요.",
    },
    privacy: {
      title: "개인정보 처리방침 | DroneSquare",
      description:
        "드론스퀘어가 수집하는 개인정보의 항목과 처리 목적, 보유 기간, 처리위탁 및 이용자의 권리를 안내합니다.",
    },
    login: {
      title: "로그인 | DroneSquare",
      description: "드론스퀘어 계정으로 로그인합니다.",
    },
    signup: {
      title: "회원가입 | DroneSquare",
      description: "드론스퀘어 계정을 만듭니다.",
    },
    changepassword: {
      title: "비밀번호 변경 | DroneSquare",
      description: "가입한 이메일로 인증번호를 받아 비밀번호를 바꿉니다.",
    },
    notFound: {
      title: "페이지를 찾을 수 없어요 | DroneSquare",
      description: "주소가 바뀌었거나 없어진 페이지예요.",
    },
    prepare: {
      title: "준비 중인 페이지예요 | DroneSquare",
      description: "빠른 시일 안에 준비해 찾아뵐게요.",
    },
    article: {
      title: "{{title}} | DroneSquare 언론보도",
    },
  },
} as const;

export default landingPages;
